import { Html, useKeyboardControls, useProgress } from "@react-three/drei";
import { useControls } from "leva";
import { useEffect, useRef, Suspense } from "react";
import { extend, useThree, useFrame } from "@react-three/fiber";

import * as THREE from "three";
import CameraControls from "./camera-controls";
import Appartement from "./Appartement.js";
import useCamera from './stores/useCamera.js'
import useVue from "./stores/useVue";
import Attendre from "./Attendre.js"
import House from "./House";

{/* --------------------------- Init CameraControls -------------------------- */ }
extend({ CameraControls });
CameraControls.install({ THREE });

/* ------------------------- fin Init CameraControls ------------------------ */



export default function Experience() {

  {/* ---------------------------------- Leva ---------------------------------- */ }
  const { sunPosition } = useControls({
    sunPosition: {
      value: [1, 2, 3],
    }
  });
  {/* -------------------------------- Fin leva -------------------------------- */ }



  {/* ------------------------------ Get Vue state ----------------------------- */ }
  const vueMode = useVue((state) => state.vueMode)
  {/* ------------------------------ Fin Get Vue state ----------------------------- */ }

  {/* --------------------- Init Camera  -------------------- */ }
  const camControl = useRef(); { /**Ref vers cameraControl */ }
  const { camera, gl, scene } = useThree(); {/**On recupere la camer et le renderer pour l'utiliser dans camera-control */ }
  const EPS = 1e-5;
  // in order to archive FPS look, set EPSILON for the distance to the center
  camera.position.set(0, 1.3, EPS);


  useEffect(() => {
    console.log(vueMode)
    if (vueMode === 'appartement') {
      camControl.current.moveTo(-3, 1.2, -2);
      camera.updateProjectionMatrix()

    }
    else if (vueMode === 'house') {
      camControl.current.moveTo(0, 10, 40)
      camera.updateProjectionMatrix()
    }

    if (vueMode === 'appartement') {
      camControl.current.rotateTo(-Math.PI * 0.5, 1.5, true)
      camera.updateProjectionMatrix()
    }
    else if (vueMode === 'house') {
      camControl.current.rotateTo(-Math.PI * 0.01, 1.5, true)
      camera.updateProjectionMatrix()
    }

    //camControl.current.moveTo(-3, 1.2, -2)
    console.log(camControl.current)




    //camControl.current.setLookAt(-3, 2, -3, 0, 1, 0, true);
    camControl.current.minDistance = camControl.current.maxDistance = 1;
    camControl.current.azimuthRotateSpeed = 0.3; // negative value to invert rotation direction
    camControl.current.polarRotateSpeed = 0.3; // negative value to invert rotation direction
    camControl.current.truckSpeed = 10;
    camControl.current.mouseButtons.wheel = CameraControls.ACTION.NONE;
    camControl.current.touches.two = CameraControls.ACTION.TOUCH_ZOOM_TRUCK;
    camControl.current.saveState();
  }, [vueMode])
  {/* --------------------- Fin Init Camera  -------------------- */ }




  {/* ------------------- Manage Keyboard for camera movemen ------------------- */ }
  const [subscribeKeys, getKeys] = useKeyboardControls()
  useFrame((state, delta) => {
    const { forward, backward, leftward, rightward } = getKeys()
    if (forward) {
      camControl.current.forward(2 * delta, false)
    }
    if (backward) {
      camControl.current.forward(-2 * delta, false)
    }
    if (leftward) {
      camControl.current.truck(-2 * delta, false)
    }
    if (rightward) {
      camControl.current.truck(2 * delta, false)
    }
  })
  {/* ------------------- Fin Manage Keyboard for camera movemen ------------------- */ }






  {/**
   * Rinit camera state to none sinon qd on click une deuxieme fois sur 
   * le meme lien la camera ne bouge plus
   */}
  const setCameraMode = useCamera((state) => state.setCameraMode)
  useEffect(() => {
    camControl.current.addEventListener('control', () => {
      setCameraMode('none')
    })
  }, [])
  {/* ------------- End ReInit camera state to none after each movement ------------ */ }

  useFrame(() => {
    camControl.current.update(0.01); {/**Update cameraControl on each frame sinon ça marche pas */ }
  });





  {/* -------------------------------- Vue Haut Function -------------------------------- */ }
  const rotateCamera = () => {
    camControl.current.moveTo(-2.5, 4, -2)
    camControl.current.rotate(-Math.PI * 0.5, -1.5, true)

  };
  {/* -------------------------- Fin Vue Haut Function ------------------------- */ }



  {/* -------------------------------- Vue principale Function -------------------------------- */ }
  const initCamera = () => {
    camControl.current.reset(true);
  };
  {/* -------------------------- Fin Vue principale Function ------------------------- */ }




  {/* ------------------------- Manage Camera positions ------------------------ */ }
  const cameraMode = useCamera((state) => {
    return state.cameraMode
  })


  useEffect(() => {
    if (cameraMode === 'top') rotateCamera()
    if (cameraMode === 'init') initCamera()
  }, [cameraMode])
  {/* -------------------------Fin Manage Camera positions ------------------------ */ }




  return (
    <>
      <cameraControls
        ref={camControl}
        args={[camera, gl.domElement]}
        verticalDragToForward={false}
      />
      {/* <Sky sunPosition={sunPosition}></Sky> */}
      {vueMode === 'house' && <House />}
      {vueMode === 'appartement' && <Appartement />}
    </>
  );
}
